// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeDhoO {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
}

.EzmV1d {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 12px;
}

.EmyvhW {
  color: var(--text-neutral-dark);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
  margin: 0;
}

.EmyvhW strong {
  font-weight: var(--font-weight-semibold);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargePaymentBenefits/RechargePaymentBenefits.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".benefits {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n}\n\n.benefitItem {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 12px;\n}\n\n.text {\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n  margin: 0;\n}\n\n.text strong {\n  font-weight: var(--font-weight-semibold);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"benefits": `LeDhoO`,
	"benefitItem": `EzmV1d`,
	"text": `EmyvhW`
};
module.exports = ___CSS_LOADER_EXPORT___;
